import Home from './home'
import ThirteenGuards from './thirteenGuards'
import GetGuardsBenefit from './getGuardsBenefit'
export default {
  Home,
  ThirteenGuards,
  GetGuardsBenefit,
}